export default __webpack_public_path__ + "static/media/serviceWave.614e6e95.png";